<script>
/**
 * @param TemplateView
 *
 * @description A listák lenyitásakor megjelenő gombokat tölti be
 */
import core from '../../utils/mixin-core'
import moment from 'moment'
import ProcessButton from '../process-builder/ProcessButton'
import ProcessButtonList from '../ProcessButtonList'
import CommonAnchorButton from '../list/buttonList/CommonAnchorButton'
import VueCircle from 'vue2-circle-progress'
import Confirmation from '../confirmation/ConfirmationList.vue'
import NumberFormatter from '../../filters/number'
import file from '../../utils/file'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import EventBus from '../../utils/event-bus'
import VideoViewer from '../video-player/VideoViewer'
import Loader from '../Loader.vue'
import QRScannerButton from '../QRScannerButton.vue'
import { get, set, isString } from 'lodash'
import { replaceRouterLinks } from '../../utils/spa-common'
import md5 from 'crypto-js/md5'
import { sanitizeHTML } from '../../utils/html-sanitizer'

const emit = (event) => {
  EventBus.$emit(event.name, event.payload)
}

export default {
  name: 'TemplateView',
  mixins: [file],
  props: {
    template: {
      type: String,
      default: '<div></div>',
    },
    css: {
      type: String,
      default: null,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  render(h) {
    // @todo templateben nem tudtam hivatkozni olyan kulcsra amiben volt kötőjel
    const params = { ...this.props, ...this.params }
    const prop = Object.assign(
      {},
      ...Object.keys(params).map((key) => ({
        [key.replace(/-/g, '_')]: isString(params[key]) ? sanitizeHTML(params[key]) : params[key],
      })),
    )
    const setExternalScript = function () {
      const functionNames = Object.keys(window).filter((key) => typeof window[key] === 'function')
      functionNames.forEach((functionName) => {
        this[functionName] = window[functionName]
      })
    }

    const setStyle = function (content) {
      const cssContentHash = md5(content).toString()
      if (get(window.CORE, ['alreadyLoadedInHeader', 'styles', 'template', cssContentHash])) return
      let style = document.createElement('style')
      style.setAttribute('style', 'text/css')
      style.appendChild(document.createTextNode(content))
      document.head.appendChild(style)
      set(window.CORE, ['alreadyLoadedInHeader', 'styles', 'template', cssContentHash], true)
    }

    const that = this

    return h(
      {
        name: 'TemplateViewRender',
        props: Object.keys(prop),
        methods: {
          moment,
          emit,
          setExternalScript,
          setStyle,
        },
        mixins: [core, file],
        filters: {
          formatNumberDecimal: NumberFormatter.formatNumberDecimal.bind(NumberFormatter),
        },
        created() {
          this.setExternalScript()
          this.setStyle(that.css)
        },
        components: {
          ProcessButton,
          ProcessButtonList,
          VueCircle,
          Confirmation,
          CommonAnchorButton,
          QRScannerButton,
          Loader,
          VueQrcode,
          VideoViewer,
        },
        template: that.template ? replaceRouterLinks(`${that.template}`) : '<div></div>',
      },
      {
        props: prop,
      },
    )
  },
}
</script>

<style></style>
